import React, { useState, useEffect, useCallback } from 'react';
import {
  Row,
  Col,
  Accordion,
  Card,
  Table,
  Badge,
  Button,
  Alert,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
  ButtonGroup,
  Spinner
} from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';
import { jwtDecode } from "jwt-decode";
import { FaEye, FaPencilAlt, FaTrash, FaCog, FaPlus } from 'react-icons/fa';

const ReceiveReturnTab = ({ purchaseOrderId, purchaseOrderVendorId, onUpdate }) => {
  const [grnList, setGrnList] = useState([]);
  const [returnNotes, setReturnNotes] = useState([]);
  const [eligibleReturns, setEligibleReturns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [formData, setFormData] = useState({
    selectedItems: [],
    reasonForReturn: 'Quality Issue',
    remarkNote: '',
    transportDetails: {
      vehicleNumber: '',
      driverName: '',
      driverContact: '',
      transportCompany: ''
    }
  });
  const [grnItems, setGrnItems] = useState({});
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showGRNItemsModal, setShowGRNItemsModal] = useState(false);
  const [selectedGRN, setSelectedGRN] = useState(null);
  const [showItemViewModal, setShowItemViewModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [availableProducts, 
    // setAvailableProducts
  ] = useState([]);
  const [addItemFormData, setAddItemFormData] = useState([]);

  const getAvailableProductOptions = (rowIndex) => {
    const totals = addItemFormData.reduce((acc, r, idx) => {
      if (idx === rowIndex) return acc;
      if (!r.productId) return acc;
      acc[r.productId] = (acc[r.productId] || 0) + (Number(r.acceptedQuantity) || 0);
      return acc;
    }, {});

    return availableProducts.filter(p => {
      const pid = p.productId;
      const already = totals[pid] || 0;
      const remaining = (Number(p.acceptedQuantity) || 0) - already;
      return remaining > 0;
    });
  };

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const createdBy = decoded.userId;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // Guard against invalid purchaseOrderId values (undefined, null, empty or string 'undefined')
      if (!purchaseOrderId || String(purchaseOrderId).trim().toLowerCase() === 'undefined') {
        console.warn('ReceiveReturnTab: invalid purchaseOrderId, skipping fetchData', purchaseOrderId);
        setLoading(false);
        return;
      }

      const [grnRes, returnRes] = await Promise.all([
        axios.get(`${config.API_BASE_URL}/grn/${purchaseOrderId}`),
        axios.get(`${config.API_BASE_URL}/return-notes?purchaseOrderId=${purchaseOrderId}`)
      ]);

      const grns = Array.isArray(grnRes.data) ? grnRes.data : [];
      setGrnList(grns);

      for (const grn of grns) {
        const itemsRes = await axios.get(`${config.API_BASE_URL}/grn-items/grn/${grn._id}`);
        setGrnItems(prev => ({
          ...prev,
          [grn._id]: itemsRes.data
        }));
      }

      setReturnNotes(returnRes.data.returnNotes || []);
    } catch (err) {
      console.error('Error fetching data:', err);
      toast.error("Error fetching data");
    }
    setLoading(false);
  },[purchaseOrderId]);

  const fetchEligibleReturns = useCallback(async () => {
    try {
      if (!purchaseOrderId || String(purchaseOrderId).trim().toLowerCase() === 'undefined') {
        console.warn('ReceiveReturnTab: invalid purchaseOrderId, skipping fetchEligibleReturns', purchaseOrderId);
        return;
      }

      const res = await axios.get(`${config.API_BASE_URL}/return-notes/eligible-returns/${purchaseOrderId}`);
      setEligibleReturns(res.data);
    } catch (err) {
      console.error('Error fetching eligible returns:', err);
      toast.error('Failed to load eligible returns');
    }
  },[purchaseOrderId]);

  // const fetchAvailableProducts = async (grnId) => {
  //   try {
  //     // Validate inputs
  //     if (!purchaseOrderId || String(purchaseOrderId).trim().toLowerCase() === 'undefined') {
  //       console.warn('fetchAvailableProducts: invalid purchaseOrderId, aborting', purchaseOrderId);
  //       return;
  //     }
  //     if (!grnId || String(grnId).trim().toLowerCase() === 'undefined') {
  //       console.warn('fetchAvailableProducts: invalid grnId, aborting', grnId);
  //       return;
  //     }

  //     // Get quality-checked items and PO items for this GRN
  //     const [qualityRes, grnRes] = await Promise.all([
  //       axios.get(`${config.API_BASE_URL}/quality-checks/${purchaseOrderId}`),
  //       axios.get(`${config.API_BASE_URL}/grn/single/${grnId}`)
  //     ]);

  //     const qualityEntries = qualityRes.data;
  //     const grn = grnRes.data;
  //     console.log("grn", grn);
  //     // Get PO items to find original ordered quantities
  //     const poItemsRes = await axios.get(`${config.API_BASE_URL}/purchase-order-items?purchaseOrderId=${grn?.purchaseOrderId}`);
  //     const poItems = poItemsRes.data;

  //     // Get existing GRN items for this GRN
  //     const existingItems = grnItems[grnId] || [];

  //     // Filter quality entries for this GRN that aren't already in GRN items
  //     const availableItems = qualityEntries
  //       .filter(q => (q.grnId === grnId || q.grnId?._id === grnId))
  //       .filter(q => {
  //         const productId = q.isAccepted ?
  //           (q.productId?._id || q.productId) :
  //           (q.acceptedProductId?._id || q.acceptedProductId);

  //         return !existingItems.some(item =>
  //           (item.productId?._id || item.productId) === productId
  //         );
  //       })
  //       .map(q => {
  //         const acceptedProductId = q.isAccepted ?
  //           (q.productId?._id || q.productId) :
  //           (q.acceptedProductId?._id || q.acceptedProductId);

  //         const acceptedProductName = q.isAccepted ?
  //           q.productId?.productName :
  //           q.acceptedProductId?.productName;

  //         // Find original ordered quantity - match by product or groupId
  //         let orderedQuantity = 0;
  //         const poItem = poItems.find(po =>
  //           (po.productId?._id || po.productId) === acceptedProductId ||
  //           (po.productId?.groupId && q.acceptedProductId?.groupId &&
  //             po.productId.groupId === q.acceptedProductId.groupId)
  //         );

  //         if (poItem) {
  //           orderedQuantity = poItem.orderedQuantity;
  //         }

  //         return {
  //           _id: q._id,
  //           productId: acceptedProductId,
  //           productName: acceptedProductName,
  //           acceptedQuantity: q.quantity, // Quality checked accepted quantity
  //           orderedQuantity: orderedQuantity, // Original PO ordered quantity
  //           unit: q.unit,
  //           quality: q.quality || 'Pending'
  //         };
  //       });

  //     setAvailableProducts(availableItems);
  //   } catch (err) {
  //     console.error('Error fetching available products:', err);
  //     toast.error('Failed to load available products');
  //   }
  // };

  // const handleAddItems = (grn) => {
  //   setSelectedGRN(grn);
  //   fetchAvailableProducts(grn._id);
  //   setAddItemFormData([{
  //     productId: '',
  //     orderedQuantity: 0,
  //     acceptedQuantity: 0,
  //     unloadedQuantity: 0,
  //     unit: '',
  //     quality: ''
  //   }]);
  //   setShowAddItemModal(true);
  // };

  const handleSaveGRNItems = async () => {
    setIsSubmitting(true);
    try {
      const validItems = addItemFormData.filter(item => item.productId && item.acceptedQuantity > 0);

      if (validItems.length === 0) {
        toast.error('Please add at least one valid item');
        return;
      }

      // Map to backend expected format
      const itemsToSave = validItems.map(item => ({
        productId: item.productId,
        orderedQuantity: item.orderedQuantity, // Original PO quantity
        unloadedQuantity: item.unloadedQuantity,
        acceptedQuantity: item.acceptedQuantity, // Quality accepted quantity
        unit: item.unit,
        quality: item.quality
      }));

      await axios.post(`${config.API_BASE_URL}/grn-items`, {
        grnId: selectedGRN._id,
        items: itemsToSave
      });

      toast.success('Items added successfully');
      setShowAddItemModal(false);
      await fetchGRNItems(selectedGRN._id);
    } catch (error) {
      console.error('Error saving GRN items:', error);
      toast.error('Failed to save items');
    } finally {
      setIsSubmitting(false);
    }
  };

  const addNewItemRow = () => {
    setAddItemFormData([...addItemFormData, {
      productId: '',
      orderedQuantity: 0,
      acceptedQuantity: 0,
      unloadedQuantity: 0,
      unit: '',
      quality: ''
    }]);
  };

  const removeItemRow = (index) => {
    setAddItemFormData(addItemFormData.filter((_, i) => i !== index));
  };

  const updateItemRow = (index, field, value) => {
    const updated = [...addItemFormData];
    updated[index][field] = value;

    // Auto-fill data when product is selected
    if (field === 'productId') {
      const product = availableProducts.find(p => p.productId === value);
      if (product) {
        // Calculate already selected qty for this product in other rows
        const alreadySelected = addItemFormData.reduce((sum, r, idx) => {
          if (idx === index) return sum;
          if (r.productId === value) return sum + (Number(r.acceptedQuantity) || 0);
          return sum;
        }, 0);

        const totalAccepted = Number(product.acceptedQuantity) || 0;
        const remaining = Math.max(0, totalAccepted - alreadySelected);

        updated[index].unit = product.unit;
        // Prefill acceptedQuantity and unloadedQuantity with remaining available quantity
        updated[index].acceptedQuantity = remaining;
        updated[index].unloadedQuantity = remaining;
        updated[index].quality = product.quality;
        updated[index].orderedQuantity = product.orderedQuantity; // Original PO qty
      }
    }

    setAddItemFormData(updated);
  };

  const fetchGRNItems = async (grnId) => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/grn-items/grn/${grnId}`);
      setGrnItems(prev => ({
        ...prev,
        [grnId]: res.data
      }));
    } catch (err) {
      console.error('Error fetching GRN items:', err);
      toast.error('Failed to load GRN items');
    }
  };

  useEffect(() => {
    // Only fetch when a valid purchaseOrderId is provided
    if (!purchaseOrderId || String(purchaseOrderId).trim().toLowerCase() === 'undefined') {
      console.warn('ReceiveReturnTab: invalid purchaseOrderId in useEffect, skipping initial fetches', purchaseOrderId);
      return;
    }

    fetchData();
    fetchEligibleReturns();
  }, [purchaseOrderId, fetchData, fetchEligibleReturns]);

  const handleCreateReturnNote = async () => {
    setIsSubmitting(true);
    try {
      if (!formData.selectedItems || formData.selectedItems.length === 0) {
        toast.error('Please select at least one item');
        return;
      }

      if (!formData.remarkNote) {
        toast.error('Please enter remarks');
        return;
      }

      const payload = {
        purchaseOrderId,
        grnId: formData.selectedItems[0].grnId._id,
        vendorId: purchaseOrderVendorId,
        items: formData.selectedItems.map(item => ({
          productId: item.productId._id,
          qualityCheckId: item._id,
          quality: item.quality,
          returnedQuantity: item.quantity,
          unit: item.unit
        })),
        reasonForReturn: formData.reasonForReturn,
        remarkNote: formData.remarkNote,
        status: 'Generated',
        transportDetails: formData.transportDetails,
        createdBy: createdBy
      };

      await axios.post(
        `${config.API_BASE_URL}/return-notes`,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        }
      );

      toast.success('Return note created successfully');
      setShowCreateModal(false);
      resetFormData();
      fetchData();
      fetchEligibleReturns();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error('Error creating return note:', err);
      toast.error(err.response?.data?.message || 'Error creating return note');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetFormData = () => {
    setFormData({
      selectedItems: [],
      reasonForReturn: 'Quality Issue',
      remarkNote: '',
      status: 'Generated',
      acknowledgmentDate: '',
      creditNoteAmount: '',
      transportDetails: {
        vehicleNumber: '',
        driverName: '',
        driverContact: '',
        transportCompany: ''
      }
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      Generated: 'secondary',
      'In Transit': 'info',
      Completed: 'success',
      Cancelled: 'danger'
    };
    return <Badge bg={statusMap[status] || 'secondary'}>{status}</Badge>;
  };

  const handleDeleteReturnNote = async (returnNoteId) => {
    if (window.confirm('Are you sure you want to delete this return note?')) {
      try {
        await axios.delete(`${config.API_BASE_URL}/return-notes/${returnNoteId}`);
        toast.success('Return note deleted successfully');
        fetchData();
      } catch (error) {
        toast.error('Error deleting return note');
      }
    }
  };

  const handleViewNote = (note) => {
    setSelectedNote(note);
    setShowViewModal(true);
  };

  const handleEditNote = (note) => {
    setSelectedNote(note);
    setShowUpdateModal(true);
  };

  const handleViewItem = (item) => {
    setSelectedItem(item);
    setShowItemViewModal(true);
  };

  const handleUpdateGRNItem = async (itemId, updatedData) => {
    setIsSubmitting(true);
    try {
      await axios.put(`${config.API_BASE_URL}/grn-items/${itemId}`, updatedData);
      await fetchGRNItems(selectedGRN._id);
      toast.success('GRN item updated successfully');
    } catch (error) {
      console.error('Error updating GRN item:', error);
      toast.error('Failed to update GRN item');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReconcileGRNItems = async (grnId) => {
    setIsSubmitting(true);
    try {
      const res = await axios.post(`${config.API_BASE_URL}/grn-items/reconcile/${grnId}`);
      toast.success(res.data.message || 'Reconciliation successful');
      await fetchGRNItems(grnId);
      if (onUpdate) onUpdate(); // Trigger parent update for PO status
    } catch (error) {
      console.error('Error reconciling GRN items:', error);
      toast.error(error.response?.data?.message || 'Failed to reconcile items');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Enhanced GRN Items Table Component
  const EnhancedGRNItemsTable = ({ items, grnId, showActions = true, isSubmitting }) => (
    <div className="table-responsive">
      {items.length === 0 ? (
        <div className="text-center py-4">
          <Alert variant="info" className="mb-3">
            No items unloaded yet. Items will be automatically added when products are unloaded to this GRN.
          </Alert>
        </div>
      ) : (
        <>
          {/* <div className="d-flex justify-content-between align-items-center mb-2">
            <small className="text-muted">{items.length} item(s) - Items are automatically added when unloading</small>
          </div> */}
          <Table striped bordered hover size="sm">
            <thead className="table-light">
              <tr>
                <th>Product</th>
                <th>Original Product</th>
                <th>Ordered Qty</th>
                <th>Unloaded Qty</th>
                <th>Accepted Qty</th>
                <th>Rejected Qty</th>
                <th>Unit Price (INR)</th>
                {/* <th>Status</th> */}
                {showActions && <th width="120">Actions</th>}
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item._id}>
                  <td>
                    <div className="fw-medium">{item.productId?.productName}</div>
                    {/* <small className="text-muted">{item.unit}</small> */}
                  </td>
                  <td>
                    {item.originalProductId?.productName || '-'}
                    {item.originalProductId && item.originalProductId.productName !== item.productId?.productName && (
                      <small className="text-muted d-block">Substitution</small>
                    )}
                  </td>
                  <td>{item.orderedQuantity} {item.unit}</td>
                  <td>{item.unloadedQuantity} {item.unit}</td>
                  <td>
                    <span className="text-success fw-medium">{item.acceptedQuantity || 0} {item.unit}</span>
                  </td>
                  <td>
                    <span className="text-danger fw-medium">{item.rejectedQuantity || 0} {item.unit}</span>
                  </td>
                  <td>
                    {/* <Badge bg={item.quality ? 'info' : 'secondary'}>
                      {item.quality || 'Pending'}
                    </Badge> */}
                    {item.orderItemUnitPrice || '-'}
                  </td>
                  {/* <td>
                    <Badge bg={item.status === 'Completed' ? 'success' : 'warning'}>
                      {item.status || 'Pending'}
                    </Badge>
                  </td> */}
                  {showActions && (
                    <td>
                      <ButtonGroup size="sm">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>View Details</Tooltip>}
                        >
                          <Button
                            variant="outline-info"
                            onClick={() => handleViewItem(item)}
                          >
                            <FaEye />
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Edit Item</Tooltip>}
                        >
                          <Button
                            variant="outline-primary"
                            onClick={() => {
                              setSelectedItem(item);
                              setSelectedGRN({ _id: grnId });
                              setShowGRNItemsModal(true);
                            }}
                          >
                            <FaPencilAlt />
                          </Button>
                        </OverlayTrigger>
                      </ButtonGroup>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );

  // GRN Details Component
  const renderGRNDetails = (grn, isSubmitting) => (
    <Card className="border-0">
      <Card.Body>
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <small className="text-muted">GRN Number:</small><br />
              <strong>{grn.grnId}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted">Received By:</small><br />
              <strong>{grn.received_by}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted">Received Date:</small><br />
              <strong>{new Date(grn.createdAt).toLocaleDateString()}</strong>
            </div>
          </Col>
          <Col md={6}>
            {grn.invoice_number && (
              <>
                <div className="mb-3">
                  <small className="text-muted">Invoice Number:</small><br />
                  <strong>{grn.invoice_number}</strong>
                </div>
                <div className="mb-3">
                  <small className="text-muted">Invoice Date:</small><br />
                  <strong>{new Date(grn.invoice_date).toLocaleDateString()}</strong>
                </div>
              </>
            )}
            {grn.vehicle_number && (
              <div className="mb-3">
                <small className="text-muted">Vehicle Number:</small><br />
                <strong>{grn.vehicle_number}</strong>
              </div>
            )}
          </Col>
        </Row>

        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Received Items</h6>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setSelectedGRN(grn);
                setShowGRNItemsModal(true);
              }}
            >
              <FaCog className="me-1" />
              Manage All Items
            </Button>
          </div>
          <EnhancedGRNItemsTable
            items={grnItems[grn._id] || []}
            grnId={grn._id}
            showActions={true}
            isSubmitting={isSubmitting}
          />
        </div>

        {grn.notes && (
          <div className="mt-3">
            <small className="text-muted">Notes:</small>
            <p className="mb-0">{grn.notes}</p>
          </div>
        )}
      </Card.Body>
    </Card>
  );

  // Update Return Note Form Component
  const UpdateReturnNoteForm = ({ returnNote, onUpdate, onCancel, isSubmitting }) => {
    const [formData, setFormData] = useState({
      status: returnNote.status || 'Generated',
      items: returnNote.items || [],
      acknowledgmentDate: returnNote.acknowledgmentDate ? new Date(returnNote.acknowledgmentDate).toISOString().split('T')[0] : '',
      creditNoteAmount: returnNote.creditNoteAmount || '',
      transportDetails: {
        vehicleNumber: returnNote.transportDetails?.vehicleNumber || '',
        driverName: returnNote.transportDetails?.driverName || '',
        driverContact: returnNote.transportDetails?.driverContact || '',
        transportCompany: returnNote.transportDetails?.transportCompany || ''
      },
      remarkNote: returnNote.remarkNote || ''
    });

    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      try {
        const payload = {
          ...formData,
          updatedBy: localStorage.getItem('userId')
        };

        await axios.put(
          `${config.API_BASE_URL}/return-notes/${returnNote._id}`,
          payload,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        toast.success('Return note updated successfully');
        onUpdate();
      } catch (error) {
        console.error('Error updating return note:', error);
        toast.error(error.response?.data?.message || 'Error updating return note');
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={formData.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              >
                <option value="Generated">Generated</option>
                <option value="Sent to Vendor">Sent to Vendor</option>
                <option value="Acknowledged">Acknowledged</option>
                <option value="Returned">Returned</option>
                <option value="Credit Note Received">Credit Note Received</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Acknowledgment Date</Form.Label>
              <Form.Control
                type="date"
                value={formData.acknowledgmentDate}
                onChange={(e) => setFormData({ ...formData, acknowledgmentDate: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Items</Form.Label>
          <Table size="sm" bordered>
            <thead>
              <tr>
                <th>Product</th>
                <th>Quality</th>
                <th>Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {formData.items.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.productId?.name || item.productId?.productName}</td>
                  <td>{item.quality}</td>
                  <td>
                    <Form.Control
                      type="number"
                      size="sm"
                      value={item.returnedQuantity}
                      onChange={(e) => {
                        const newItems = [...formData.items];
                        newItems[idx].returnedQuantity = Number(e.target.value);
                        setFormData({ ...formData, items: newItems });
                      }}
                    />
                  </td>
                  <td>{item.unit}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Credit Note Amount</Form.Label>
          <Form.Control
            type="number"
            value={formData.creditNoteAmount}
            onChange={(e) => setFormData({ ...formData, creditNoteAmount: Number(e.target.value) })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Transport Details</Form.Label>
          <Row>
            <Col md={6}>
              <Form.Control
                className="mb-2"
                placeholder="Vehicle Number"
                value={formData.transportDetails.vehicleNumber}
                onChange={(e) => setFormData({
                  ...formData,
                  transportDetails: {
                    ...formData.transportDetails,
                    vehicleNumber: e.target.value
                  }
                })}
              />
            </Col>
            <Col md={6}>
              <Form.Control
                className="mb-2"
                placeholder="Transport Company"
                value={formData.transportDetails.transportCompany}
                onChange={(e) => setFormData({
                  ...formData,
                  transportDetails: {
                    ...formData.transportDetails,
                    transportCompany: e.target.value
                  }
                })}
              />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Remarks</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={formData.remarkNote}
            onChange={(e) => setFormData({ ...formData, remarkNote: e.target.value })}
          />
        </Form.Group>

        <div className="d-flex justify-content-end gap-2">
          <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Updating...' : 'Update Return Note'}
          </Button>
        </div>
      </Form>
    );
  };

  // GRN Item Edit Form Component
  const GRNItemEditForm = ({ item, onSave, onCancel, isSubmitting }) => {
    const [formData, setFormData] = useState({
      unloadedQuantity: item.unloadedQuantity || 0,
      acceptedQuantity: item.acceptedQuantity || 0,
      rejectedQuantity: item.rejectedQuantity || 0,
      quality: item.quality || '',
      qualityRemarks: item.qualityRemarks || ''
    });

    const handleSubmit = (e) => {
      e.preventDefault();
      onSave(formData);
    };

    return (
      <Form onSubmit={handleSubmit}>
        <div className="mb-3">
          <h6>Product: {item.productId?.productName}</h6>
          <small className="text-muted">Ordered Quantity: {item.orderedQuantity} {item.unit}</small>
        </div>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Unloaded Quantity</Form.Label>
              <Form.Control
                type="number"
                value={formData.unloadedQuantity}
                onChange={(e) => setFormData({
                  ...formData,
                  unloadedQuantity: Number(e.target.value)
                })}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Quality Grade</Form.Label>
              <Form.Control
                type="text"
                value={formData.quality}
                onChange={(e) => setFormData({
                  ...formData,
                  quality: e.target.value
                })}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Accepted Quantity</Form.Label>
              <Form.Control
                type="number"
                value={formData.acceptedQuantity}
                onChange={(e) => setFormData({
                  ...formData,
                  acceptedQuantity: Number(e.target.value)
                })}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Rejected Quantity</Form.Label>
              <Form.Control
                type="number"
                value={formData.rejectedQuantity}
                onChange={(e) => setFormData({
                  ...formData,
                  rejectedQuantity: Number(e.target.value)
                })}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <Form.Label>Quality Remarks</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={formData.qualityRemarks}
            onChange={(e) => setFormData({
              ...formData,
              qualityRemarks: e.target.value
            })}
          />
        </Form.Group>
        <div className="d-flex justify-content-end gap-2">
          <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </Form>
    );
  };

  return (
    <div className="receive-return-tab">
      <h5 className="mb-4">Goods Receipt Notes (GRN)</h5>

      {/* GRN Accordion */}
      <Accordion className="mb-5">
        {grnList.map((grn, idx) => (
          <Accordion.Item key={idx} eventKey={idx.toString()}>
            <Accordion.Header>
              <div className="d-flex justify-content-between align-items-center w-100 me-3">
                <span><strong>GRN #{grn.grnId}</strong></span>
                <span className="text-muted">
                  Date: {new Date(grn.createdAt).toLocaleDateString()}
                </span>
                <div>
                  <Badge bg={grn.status === 'Completed' ? 'success' : 'warning'}>
                    {grn.status}
                  </Badge>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              {renderGRNDetails(grn, isSubmitting)}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      {/* Return Notes Section */}
      <div className="return-notes-section">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0">Return Notes</h5>
          <Button
            variant="primary"
            size="sm"
            onClick={() => setShowCreateModal(true)}
            disabled={!grnList.length}
          >
            <i className="bi bi-plus-circle me-1"></i>
            Generate Return Note
          </Button>
        </div>

        {/* Return Notes List */}
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : returnNotes.length > 0 ? (
          <Table responsive hover>
            <thead className="bg-light">
              <tr>
                <th>Return Note #</th>
                <th>GRN Reference</th>
                <th>Items</th>
                <th>Return Date</th>
                <th>Status</th>
                <th width="150">Actions</th>
              </tr>
            </thead>
            <tbody>
              {returnNotes.map(note => (
                <tr key={note._id}>
                  <td><strong>{note.returnNoteId}</strong></td>
                  <td>{note.grnId?.grnId}</td>
                  <td>
                    {note.items?.map(item => (
                      <div key={item._id} className="small">
                        {item.productId?.productName} - {item.returnedQuantity} {item.unit}
                      </div>
                    ))}
                  </td>
                  <td>{new Date(note.acknowledgmentDate || note.createdAt).toLocaleDateString()}</td>
                  <td>{getStatusBadge(note.status)}</td>
                  <td>
                    <ButtonGroup size="sm">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>View Details</Tooltip>}
                      >
                        <Button variant="outline-info" onClick={() => handleViewNote(note)}>
                          <FaEye />
                        </Button>
                      </OverlayTrigger>

                      {note.status === 'Generated' && (
                        <>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Edit Note</Tooltip>}
                          >
                            <Button variant="outline-warning" onClick={() => handleEditNote(note)}>
                              <FaPencilAlt />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Delete Note</Tooltip>}
                          >
                            <Button variant="outline-danger" onClick={() => handleDeleteReturnNote(note._id)}>
                              <FaTrash />
                            </Button>
                          </OverlayTrigger>
                        </>
                      )}
                    </ButtonGroup>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <Alert variant="info">No return notes available</Alert>
        )}
      </div>

      {/* Create Return Note Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create Return Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Rejected Items</Form.Label>
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {eligibleReturns.map((item) => (
                  <Form.Check
                    key={item._id}
                    type="checkbox"
                    label={`${item.productId?.productName} - Quality: ${item.quality} - Qty: ${item.quantity} (GRN: ${item.grnId?.grnId})`}
                    checked={formData.selectedItems.some(selected => selected._id === item._id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setFormData({
                          ...formData,
                          selectedItems: [...formData.selectedItems, item]
                        });
                      } else {
                        setFormData({
                          ...formData,
                          selectedItems: formData.selectedItems.filter(selected => selected._id !== item._id)
                        });
                      }
                    }}
                  />
                ))}
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Reason for Return</Form.Label>
              <Form.Select
                value={formData.reasonForReturn}
                onChange={(e) => setFormData({ ...formData, reasonForReturn: e.target.value })}
                required
              >
                <option value="Quality Issue">Quality Issue</option>
                <option value="Wrong Product">Wrong Product</option>
                <option value="Damaged in Transit">Damaged in Transit</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Transport Details</Form.Label>
              <Row>
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="Vehicle Number"
                    value={formData.transportDetails.vehicleNumber}
                    onChange={(e) => setFormData({
                      ...formData,
                      transportDetails: {
                        ...formData.transportDetails,
                        vehicleNumber: e.target.value
                      }
                    })}
                    className="mb-2"
                  />
                </Col>
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="Transport Company"
                    value={formData.transportDetails.transportCompany}
                    onChange={(e) => setFormData({
                      ...formData,
                      transportDetails: {
                        ...formData.transportDetails,
                        transportCompany: e.target.value
                      }
                    })}
                    className="mb-2"
                  />
                </Col>
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="Driver Name"
                    value={formData.transportDetails.driverName}
                    onChange={(e) => setFormData({
                      ...formData,
                      transportDetails: {
                        ...formData.transportDetails,
                        driverName: e.target.value
                      }
                    })}
                    className="mb-2"
                  />
                </Col>
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="Driver Contact"
                    value={formData.transportDetails.driverContact}
                    onChange={(e) => setFormData({
                      ...formData,
                      transportDetails: {
                        ...formData.transportDetails,
                        driverContact: e.target.value
                      }
                    })}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={formData.remarkNote}
                onChange={(e) => setFormData({ ...formData, remarkNote: e.target.value })}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            {isSubmitting ? 'Submitting...' : 'Cancel'}
          </Button>
          <Button variant="primary" onClick={handleCreateReturnNote} disabled={isSubmitting}>
            {isSubmitting
              ? "Generating..."
              : "Generate Return Note"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Return Note Modal */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Return Note Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedNote && (
            <div>
              <Row>
                <Col md={6}>
                  <p><strong>Return Note #:</strong> {selectedNote.returnNoteId}</p>
                  <p><strong>GRN Reference:</strong> {selectedNote.grnId?.grnNumber}</p>
                  <p><strong>Return Date:</strong> {new Date(selectedNote.createdAt).toLocaleDateString()}</p>
                  <p><strong>Status:</strong> {getStatusBadge(selectedNote.status)}</p>
                </Col>
                <Col md={6}>
                  <p><strong>Reason:</strong> {selectedNote.reasonForReturn}</p>
                  <p><strong>Transport Company:</strong> {selectedNote.transportDetails?.transportCompany || 'N/A'}</p>
                  <p><strong>Vehicle Number:</strong> {selectedNote.transportDetails?.vehicleNumber || 'N/A'}</p>
                  <p><strong>Driver:</strong> {selectedNote.transportDetails?.driverName || 'N/A'}</p>
                </Col>
              </Row>
              <hr />
              <h6>Returned Items</h6>
              <Table responsive size="sm">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Quality Grade</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedNote.items?.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.productId?.productName}</td>
                      <td>{item.returnedQuantity} {item.unit}</td>
                      <td>{item.quality}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="mt-3">
                <strong>Remarks:</strong>
                <p className="mb-0">{selectedNote.remarkNote}</p>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Update Return Note Modal */}
      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update Return Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UpdateReturnNoteForm
            isSubmitting={isSubmitting}
            returnNote={selectedNote}
            onUpdate={() => {
              fetchData();
              setShowUpdateModal(false);
              if (onUpdate) onUpdate();
            }}
            onCancel={() => setShowUpdateModal(false)}
          />
        </Modal.Body>
      </Modal>

      {/* GRN Items Management Modal */}
      <Modal show={showGRNItemsModal} onHide={() => setShowGRNItemsModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedItem ? 'Edit GRN Item' : `Manage GRN Items - ${selectedGRN?.grnId}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem ? (
            <GRNItemEditForm
              isSubmitting={isSubmitting}
              item={selectedItem}
              onSave={async (updatedData) => {
                await handleUpdateGRNItem(selectedItem._id, updatedData);
                setSelectedItem(null);
              }}
              onCancel={() => setSelectedItem(null)}

            />
          ) : (
            <EnhancedGRNItemsTable
              items={grnItems[selectedGRN?._id] || []}
              grnId={selectedGRN?._id}
              showActions={false}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {!selectedItem && selectedGRN && (
            <Button 
              variant="outline-warning" 
              className="me-auto"
              onClick={() => handleReconcileGRNItems(selectedGRN._id)}
              disabled={isSubmitting}
            >
              {isSubmitting ? <Spinner size="sm" /> : <FaCog className="me-1" />}
              Reconcile Items
            </Button>
          )}
          <Button variant="secondary" onClick={() => {
            setShowGRNItemsModal(false);
            setSelectedItem(null);
          }}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Item View Modal */}
      <Modal show={showItemViewModal} onHide={() => setShowItemViewModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Item Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <Row>
                <Col md={6}>
                  <p><strong>Product:</strong> {selectedItem.productId?.productName}</p>
                  <p><strong>Unit:</strong> {selectedItem.unit}</p>
                  <p><strong>Ordered Quantity:</strong> {selectedItem.orderedQuantity}</p>
                  <p><strong>Unloaded Quantity:</strong> {selectedItem.unloadedQuantity}</p>
                </Col>
                <Col md={6}>
                  <p><strong>Accepted Quantity:</strong> <span className="text-success">{selectedItem.acceptedQuantity || 0}</span></p>
                  <p><strong>Rejected Quantity:</strong> <span className="text-danger">{selectedItem.rejectedQuantity || 0}</span></p>
                  <p><strong>Quality Grade:</strong> {selectedItem.quality || 'Pending'}</p>
                  <p><strong>Status:</strong> {getStatusBadge(selectedItem.status || 'Pending')}</p>
                </Col>
              </Row>
              {selectedItem.qualityRemarks && (
                <div className="mt-3">
                  <strong>Quality Remarks:</strong>
                  <p className="mb-0">{selectedItem.qualityRemarks}</p>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowItemViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Item Add Modal */}
      <Modal show={showAddItemModal} onHide={() => setShowAddItemModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Items to GRN - {selectedGRN?.grnId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {availableProducts.length === 0 ? (
            <Alert variant="info">
              No quality-checked items available to add to this GRN.
            </Alert>
          ) : (
            <div className="table-responsive">
              <Table bordered>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Quality Qty</th>
                    <th>Unloaded Qty</th>
                    <th>Quality Grade</th>
                    <th width="50">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {addItemFormData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Select
                          value={item.productId}
                          onChange={(e) => updateItemRow(index, 'productId', e.target.value)}
                          required
                        >
                          <option value="">Select Product</option>
                          {getAvailableProductOptions(index).map(product => {
                            const alreadySelected = addItemFormData.reduce((sum, r, idx) => {
                              if (idx === index) return sum;
                              if (r.productId === product.productId) return sum + (Number(r.acceptedQuantity) || 0);
                              return sum;
                            }, 0);
                            const remaining = Math.max(0, (Number(product.acceptedQuantity) || 0) - alreadySelected);
                            return (
                              <option key={product._id} value={product.productId}>
                                {product.productName} {`(Available: ${remaining} ${product.unit || ''})`}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </td>
                      <td>
                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            value={item.acceptedQuantity}
                            onChange={(e) => updateItemRow(index, 'acceptedQuantity', Number(e.target.value))}
                            required
                          />
                          {item.unit && (
                            <span className="position-absolute top-50 end-0 translate-middle-y pe-2 text-muted small">
                              {item.unit}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            value={item.unloadedQuantity}
                            onChange={(e) => updateItemRow(index, 'unloadedQuantity', Number(e.target.value))}
                            required
                          />
                          {item.unit && (
                            <span className="position-absolute top-50 end-0 translate-middle-y pe-2 text-muted small">
                              {item.unit}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={item.quality}
                          onChange={(e) => updateItemRow(index, 'quality', e.target.value)}
                          placeholder="Quality grade"
                        />
                      </td>
                      <td>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => removeItemRow(index)}
                          disabled={addItemFormData.length === 1}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          <Button variant="outline-primary" onClick={addNewItemRow} className="mt-2" disabled={availableProducts.length === 0}>
            <FaPlus className="me-1" />
            Add Another Item
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddItemModal(false)}>
            {isSubmitting ? 'Submitting...' : 'Cancel'}
          </Button>
          <Button variant="primary" onClick={handleSaveGRNItems} disabled={availableProducts.length === 0 || isSubmitting}>
            {isSubmitting
              ? "Saving..."
              : "Save Items"}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default ReceiveReturnTab;
